module.exports = __webpack_public_path__ + "static/img/bocai.84976667.png";